import React from 'react';
import SvgIcon from './SvgIcon'

import helpers from '../lib/helpers';

import SafeLink from './SafeLink';

export default (props) => {
  return (
    <div className="o-container">
      <div className="p-infobox__wrapper">
        <div className="p-infobox__inner">
          <div className="p-infobox__title-wrapper">
            <h3 className="p-infobox__title e-typo--btm-left-short-border">Did you know?</h3>
          </div>
          <ul className="p-infobox__list">
            {props.boxes && 
              props.boxes.map(box=>
                <li className={"p-infobox__item p-infobox--triangle-right " + box.bgColor}>
                  <div className="p-infobox__top">
                    <h4 className="p-infobox__heading">
                      {box.title}

                      {!!box.iconUrl &&
                        <span className="p-infobox__heading__icon">
                          <img src={box.iconUrl} alt="Man icon"/>
                        </span>
                      }
                    </h4>
                  </div>
                  <div className="p-infobox__mid">
                    <p>{box.content}</p>
                  </div>
                  {!!box.linkText &&
                    <div className="p-infobox__btm">
                      {!box.linkInternal && !!box.linkUrl &&
                        <a href={box.linkUrl} className="p-infobox__link" target="_blank" title="open in a new tab">
                          {box.linkText}
                          <span className="p-infobox__link__icon">
                            <SvgIcon className="c-icon" imageName="ico-arrow-right" />
                          </span>
                        </a>
                      }

                      {!!box.linkInternal && !!box.linkId &&
                        <SafeLink to={helpers.getUrlTitle(box.linkId)} className="p-infobox__link">
                          {box.linkText}
                          <span className="p-infobox__link__icon">
                            <SvgIcon className="c-icon" imageName="ico-arrow-right" />
                          </span>
                        </SafeLink>
                      }
                    </div>
                  }
                </li>
              )
            }
          </ul>
        </div>
      </div>
    </div>
  );
}